/* eslint-disable import/prefer-default-export */
import http from './httpClient';

export const getProfile = async cod => {
  try {
    const result = await http.get(`/patients/${cod}/`);
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getPatientMedicalRecords = async codPatient => {
  try {
    const res = await http.get('/medical_record/',
      {
        params: {
          patient_id: codPatient,
        },
        headers: { Authorization: `Token ${localStorage.getItem('user-token')}` },
      },
    );
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const sendTherapistInterviewForm = async form => {
  try {
    const result = await http.post('/patient_questions/', form, {
      Authorization: `Token ${localStorage.getItem('user-token')}`,
    });
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
};
